import type { RouteRecordRaw } from 'vue-router'

const qrfsRoutes: RouteRecordRaw[] = [
  {
    path: '/qrfs',
    name: 'qrfs.index',
    component: () => import('@/modules/qrf/views/QRFsIndex.vue'),
    meta: {
      pageTitle: 'QRFs',
      breadcrumbs: ['QRFs']
    }
  },
  {
    path: '/qrfs/:id',
    name: 'qrfs.show',
    component: () => import('@/modules/qrf/views/QRFsShow.vue'),
    meta: {
      pageTitle: 'QRFs',
      breadcrumbs: ['QRFs']
    }
  },
  {
    path: '/qrfs/create',
    name: 'qrfs.create',
    component: () => import('@/modules/qrf/views/QRFsEdit.vue'),
    meta: {
      pageTitle: 'QRFs',
      breadcrumbs: ['QRFs']
    }
  },
  {
    path: '/qrfs/:id/edit',
    name: 'qrfs.edit',
    component: () => import('@/modules/qrf/views/QRFsEdit.vue'),
    meta: {
      pageTitle: 'QRFs',
      breadcrumbs: ['QRFs']
    }
  }
]

export default qrfsRoutes
